export const Role = {
  ADMIN: "Адміністратор",
  TEACHER: "Викладач",
  STUDENT: "Студент",
  DEFAULT: "Користувач",
};
